import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BilingualText } from '../components/BilingualText';
import { BilingualButton } from '../components/BilingualButton';
import { BrandHeader } from '../components/BrandHeader';
import { dict } from '../i18n/dictionary';

export function PunchSuccess() {
  const { type } = useParams<{ type: 'in' | 'out' }>();
  const navigate = useNavigate();
  const [now] = useState(() => new Date());

  useEffect(() => {
    const t = setTimeout(() => navigate('/punch'), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  const h = String(now.getHours()).padStart(2, '0');
  const m = String(now.getMinutes()).padStart(2, '0');

  return (
    <main className="page page-success">
      <BrandHeader />
      <div className="check-mark" aria-hidden>
        ✓
      </div>
      <div className="big-time">{h}:{m}</div>
      <h2>
        <BilingualText
          value={type === 'in' ? dict.punchedInSuccess : dict.punchedOutSuccess}
        />
      </h2>
      <p className="take-care">
        <BilingualText value={dict.takeCare} separator="slash" />
      </p>
      <BilingualButton
        label={dict.goHome}
        variant="primary"
        onClick={() => navigate('/punch')}
      />
    </main>
  );
}
